module.exports = __webpack_public_path__ + "static/media/25542643_1703517306390120_1706380912572260586_o.05effa85.jpg";